export const FIXED_POSITION_INTERNAL_MENU = {
  left: -140,
  top: 2,
};
export const TIME_WAIT_CONFIRM_DELETION = 5000;
